import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthUser } from '../../auth/auth.types';

type AuthState = {
  user: AuthUser | null;
};

const initialState: AuthState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthUser(state, action: PayloadAction<AuthUser | null>) {
      state.user = action.payload;
    },
    resetAuth(state) {
      state.user = null;
    },
  },
});

export const { setAuthUser, resetAuth } = authSlice.actions;
export default authSlice.reducer;